import { put, call } from 'redux-saga/effects';
import * as types from '../../../actions'; 
import { listVehicleFieldsMaster, addVehicleFieldaMaster, updateVehicleFieldaMaster, deleteVehicleFieldsMaster} from '../../../services/settings/superadmin/vehicleInfoMasterService';

export function* listVehicleFieldsMasterSaga(payload) { 
    try {
    	yield put({ type: types.SHOW_LOADER})
      	const response = yield call(listVehicleFieldsMaster, payload);
      	yield put({ type: types.LIST_VEHICLE_FIELDS_MASTER_SUCCESS, response })
      
    } catch(error) {
      yield put({ type: types.LIST_VEHICLE_FIELDS_MASTER_ERROR, error });
    }finally{
      yield put({ type: types.HIDE_LOADER})
  }
}

export function* addVehicleFieldaMasterSaga(payload) { 
    try {
    	yield put({ type: types.SHOW_LOADER})
	    const response = yield call(addVehicleFieldaMaster, payload);
	    yield put({ type: types.ADD_VEHICLE_FIELDS_MASTER_SUCCESS, response })
      
    } catch(error) {
      yield put({ type: types.ADD_VEHICLE_FIELDS_MASTER_ERROR, error });
    }finally{
      yield put({ type: types.HIDE_LOADER})
  }
}

export function* updateVehicleFieldaMasterSaga(payload) { 
  try {
    yield put({ type: types.SHOW_LOADER})
    const response = yield call(updateVehicleFieldaMaster, payload);
    yield put({ type: types.UPDATE_VEHICLE_FIELDS_MASTER_SUCCESS, response })
    
  } catch(error) {
    yield put({ type: types.UPDATE_VEHICLE_FIELDS_MASTER_ERROR, error });
  }finally{
    yield put({ type: types.HIDE_LOADER})
}
}

export function* deleteVehicleFieldsMasterSaga(payload) { 
  try {
    yield put({ type: types.SHOW_LOADER})
    const response = yield call(deleteVehicleFieldsMaster, payload);
    yield put({ type: types.DELETE_VEHICLE_FIELDS_MASTER_SUCCESS, response })
    
  } catch(error) {
    yield put({ type: types.DELETE_VEHICLE_FIELDS_MASTER_ERROR, error });
  }finally{
    yield put({ type: types.HIDE_LOADER})
}
}
